import React from 'react'
import { Link, useParams, useHistory } from 'react-router-dom'
import home_task from '../assets/home_task.svg'
import arrow_project from '../assets/arrow_project.svg'
import PREVIOUS from '../assets/PREVIOUS.svg'
import category_tool from '../assets/category_tool.svg'
function ToolNavigation({ projectName, taskName, category, taskID, projectID }) {
    const history = useHistory();
    const handleClickTask = () => {
        history.push({
            pathname: '/category/' + taskID,
        })
    }
    const handleClickProject = () => {
        history.push({
            pathname: '/task/' + projectID,
        })
    }
    return (
        <>
            <div className='navigation-task'>
                <Link to="/" className='link-navigation'>
                    <p>
                        <img src={home_task} alt="home" className="home" />
                        &nbsp;
                        <span className='home-task' >Projects</span>
                        &nbsp; &nbsp;
                    </p>
                </Link>
                <p>
                    <img src={arrow_project} alt="home" className="home" />
                    &nbsp; &nbsp;
                    <span style={{cursor: 'pointer'}} onClick={()=>handleClickProject()} className='home-task link-navigation' >{projectName}</span>
                    &nbsp; &nbsp;
                    <img src={arrow_project} alt="home" className="home" />
                    &nbsp; &nbsp;
                    <span style={{cursor: 'pointer'}} onClick={()=>handleClickTask()} className='home-task link-navigation' >{taskName}</span>
                    &nbsp; &nbsp;
                    <img src={arrow_project} alt="home" className="home" />
                    &nbsp; &nbsp;
                    <span className='project-task' >{category}</span>
                </p>
            </div>
            <div className="project-container-task">
                <div className='project-name-task' >
                    <img src={category_tool} alt="project" />
                    &nbsp; &nbsp;
                    {category}
                </div>
                <div className='back-arrow-task'>
                    <Link to={"/category/" + taskID}>
                        <img src={PREVIOUS} alt="PREVIOUS" className="PREVIOUS" />
                    </Link>
                </div>
            </div>
        </>
    )
}

export default ToolNavigation